module.exports = __webpack_public_path__ + "static/media/COVID safety video script_1662644875599.68dd1a4b.docx";